<template>
  <div class="traffic p_t">
    <TopHead title="交通信息"></TopHead>
    <div class="t_top">
      <img src="../assets/img/t_address.png" alt="">
      <div><span>地址：</span><span>乐山市峨眉山市峨眉山报国寺景区路二段322号</span></div>
    </div>
    <div class="bus_out">
      <div class="t_bus p_r">
        <div class="p_a">{{jtInfo.title}}</div>
      </div>
      <div v-html="jtInfo.contentInfo"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Traffic",
    data() {
      return {
        jtInfo:{},
      }
    },
    created(){
      this.queryContentByCode();
    },
    methods: {
      //查询交通信息
      queryContentByCode(){
        this.$api.queryContentByCode('jtxx').then(res => {
          this.jtInfo = JSON.parse(JSON.stringify(res.data));
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .t_bus{
    .p_a{
      background: url("../assets/img/traffic_bus.png") no-repeat;
      background-size: 100% 100%;
      width: 176px;
      height: 40px;
      padding-left: 36px;
      box-sizing: border-box;
      line-height: 45px;
      bottom: 0;
      left: 0;
    }
    height: 30px;
    background: #EFEFEF;
    font-size: 16px;
    font-weight: bold;
    color: #FFFFFF;
    margin-bottom: 15px;
  }
  .bus_out{
    padding: 36px 13px 20px;
  }
  .t_top{
    padding: 13px;
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    border-bottom: 1px solid #C5C5C5;
    img{
      width: 100%;
      margin-bottom: 12px;
    }
  }

</style>
